import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'https://recruitai.pingitright.com/api';

/**
 * Where a shared job link lands: /j/<code>.
 *
 * The board is one page, so opening a role never changed the address and
 * there was nothing to post on LinkedIn. Each job now has a code of its own,
 * and this looks it up and hands over to the company's board with that role
 * already open — same page the candidate would see coming from the careers
 * site, filters and application form included.
 */
export default function SharedJob() {
  const { code } = useParams();
  const [target, setTarget] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API}/portal/job-link/${encodeURIComponent(code)}`)
      .then(async (r) => {
        if (!r.ok) {
          const d = await r.json().catch(() => ({}));
          throw new Error(d.detail || 'This job is no longer open');
        }
        return r.json();
      })
      .then((payload) => {
        const token = payload?.company?.board_token;
        const jobCode = payload?.job?.public_code;
        if (!token || !jobCode) throw new Error('This job is no longer open');
        setTarget(`/embed/jobs/${token}?job=${jobCode}`);
      })
      .catch((e) => setError(e.message));
  }, [code]);

  if (target) return <Navigate to={target} replace />;

  return (
    <div style={{
      fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, textAlign: 'center', color: '#4b5563',
    }}>
      {error
        ? (
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#111827', marginBottom: 6 }}>{error}</div>
            <div style={{ fontSize: 14 }}>The role may have been filled or closed.</div>
          </div>
        )
        : <div style={{ fontSize: 14 }}>Opening this role…</div>}
    </div>
  );
}
